import EventEmitter from './EventEmitter';
import { getActiveData, getIsMutation, getIsLastDepth } from './util';
import { StateType } from '../interface/IDropdown';

class DropdownStore {
    private defaultStateData: StateType = {
        isOpen: false,
        activeKey: null,
        prevActiveKey: null,
        maxDepth: 1,
        newData: [],
        isLastDepth: false,
        activeData: [],
        isInitial: true
    };
    private stateData: StateType = this.defaultStateData;
    private emitter: EventEmitter = new EventEmitter();

    constructor() {

    }

    get state(): StateType {
        return this.stateData;
    }

    addListener(eventType: keyof StateType, callback: (...args: any[]) => any) {
        this.emitter.addEvent(eventType, callback);
    }

    setState<K extends keyof StateType, T extends StateType[K]>(stateKey: K, data: T) {
        this.state[stateKey] = data;
    }

    dispatch<K extends keyof StateType, T extends StateType[K]>(stateKey: K, data: T) {
        const prevState = this.state[stateKey];
        let isMutation = false;

        this.setState(stateKey, data);

        if(stateKey === 'activeKey' && typeof data === 'string') {
            const { newData, maxDepth } = this.state;
            this.setState('activeData', getActiveData(newData, data));
            this.setState('isLastDepth', getIsLastDepth(data, newData, maxDepth!));
        }

        isMutation = getIsMutation(prevState, this.state[stateKey]);
        isMutation && this.emitter.emit(stateKey, data);
    }

    reset() {
        this.stateData = this.defaultStateData;
        this.emitter.removeAllEvent();
    }
}

export default DropdownStore;